import { Enumeration } from '../enumeration.model';

export class ServerState extends Enumeration {
  static Requested = new ServerState('e519a6c2-133a-423d-aae2-d90703a90568', 'Requested');
  static Processing = new ServerState('03eb1d57-dffe-4200-bb7e-7a68bdbf263a', 'Processing');
  static Idle = new ServerState('d300489c-c96d-4601-bca9-9a4b7f62773c', 'Idle');
  static Terminated = new ServerState('42d78b6c-8070-4705-b1d5-d3ed7ee67300', 'Terminated');
  static Provisioning = new ServerState('63a796d5-cb15-e811-a97f-12b52d60e214', 'Provisioning');
  static Stopping = new ServerState('c63c74b1-da4f-e811-a97f-12b52d60e214', 'Stopping');
  static Stopped = new ServerState('99479982-5a58-e811-a97f-12b52d60e214', 'Stopped');

  constructor(value: string, displayName: string) {
    super(value, displayName);
  }
}
